import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-dispatch-equipment-history',
    templateUrl: './dispatch-equipment-history.component.html',
    styleUrls: ['./dispatch-equipment-history.component.scss'],
    standalone: false
})
export class DispatchEquipmentHistoryComponent implements OnInit {

    constructor() { }

    @Input() chartType: string = 'column';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.dispatchEquipmentHistory;
    chartSearchFilters: widgetFilters[] = [widgetFilters.customer,
        widgetFilters.locations,
        widgetFilters.dateRange];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

}
